import { LabMDM } from "./lab";
 
export class ProblemCategoryDTO {
    _id : string;  
    lab : LabMDM;
    categoryName : string;
    displayName : string;
    active : boolean;
    defaultCategory: boolean;
    displayList: boolean;
}